import * as React from "react";
import {cx} from "emotion";

import "./payment-details.scss";

import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {groupEnrollmentEditors} from "../../../common/group-enrollment-editors";

import {CorporateBillingAccounts} from "./payment-types/corporate-billing-accounts/corporate-billing-accounts";
import {Credits}                  from "./payment-types/credits/credits";

export const PaymentDetails = ({required, initEnrollment, program, next}) => cs(
    ["billingAccountsSection", (_, next) => CorporateBillingAccounts({initEnrollment, program, next})],
    ["credits", (_, next) => Credits({initEnrollment, program, next})],

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["hasError", ({credits, billingAccountsSection}, next) => next(required && !credits.maybeFulfilled && !billingAccountsSection.selected)],

    ({billingAccountsSection, credits, eh, domRef, hasError,}) => next({
        enrollmentEditor: groupEnrollmentEditors([
            billingAccountsSection.enrollmentEditor,
            credits.enrollmentEditor,
            {
                valid: !hasError,
                errorsHandling: {
                    highlightErrors: () => {
                        eh.start();
                        setTimeout(() => {
                            scrollIntoView(domRef.get());
                        }, 0);
                    },
                },
            },
        ]),
        render: ({showErrors}) => (
            <div {...{
                className: "payment-details payment-details-45t",
            }}>
                <div className="header">
                    <div {...{
                        className: "title",
                        "xd-qa-type": "label",
                        "xd-qa-name": "Payment Title",
                    }}>
                        Payment
                    </div>
                    <div {...{
                        className: "subtitle",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Payment Description",
                    }}>
                        Select your method(s) of payment
                    </div>
                </div>

                {hasError && (
                    <div className={cx("errors", eh.css, {show: showErrors})} ref={domRef.set}>
                        {"Please select Ad Budget or Voucher or Billing account to complete your enrollment"}
                    </div>
                )}

                <div className="box">
                    {credits.render({})}

                    {billingAccountsSection.render({})}
                </div>
            </div>
        ),
    }),
);
